import { useCallback, useRef } from "react";
import {
  runRouteGeneration,
  type GenerateRoutesArgs,
  type RouteGenerationContext,
} from "@/lib/generateRoutes";

/**
 * Returns a stable callback that runs the route-generation pipeline against
 * the latest `ctx`. We stash `ctx` in a ref so the returned function never
 * changes identity — it's safe to use as an effect dep — while still
 * reading fresh state on every invocation.
 */
export function useRouteRequest(ctx: RouteGenerationContext) {
  const ctxRef = useRef(ctx);
  ctxRef.current = ctx;
  return useCallback(
    (args: GenerateRoutesArgs) => runRouteGeneration(args, ctxRef.current),
    [],
  );
}
